export const RAPPORTS_A_SIGNER = {
    SET_ITEMS: 'SET_SUIVI_INTERVENTION_ITEMS',
    RESET_ITEMS: 'RESET_RAPPORT_A_SIGNER_ITEMS',
    ADD_ITEMS: 'ADD_RAPPORT_A_SIGNER_ITEMS',

    SET_PAGE: 'SET_RAPPORT_A_SIGNER_PAGE',
    SET_NB_OF_PAGES: 'SET_RAPPORT_A_SIGNER_NB_OF_PAGES',
    SET_SCROLL: 'SET_RAPPORTS_A_SIGNER_SCROLL',
    SET_COUNT: 'SET_RAPPORT_A_SIGNER_COUNT',

    SET_SORT: 'SET_RAPPORT_A_SIGNER_SORT',
    RAPPORT_A_SIGNER_SET_FILTER_INTERVENTION_ID: 'RAPPORT_A_SIGNER_SET_FILTER_INTERVENTION_ID',
    SET_FILTER_SITE: 'RAPPORT_A_SIGNER_SET_FILTER_SITE',
    ADD_FILTER_SITE: 'SUIVI_INTERVENTION_ADD_FILTER_SITE',
    SET_RAPPORT_A_SIGNER_SET_FILTER_SITE: 'RAPPORT_A_SIGNER_SET_FILTER_SITE',
    SUIVI_RAPPORT_A_SIGNER_SET_FILTER_PREDICTED_DATE_FROM: 'SUIVI_RAPPORT_A_SIGNER_SET_FILTER_PREDICTED_DATE_FROM',
    SUIVI_RAPPORT_A_SIGNER_SET_FILTER_PREDICTED_DATE_TO: 'SUIVI_RAPPORT_A_SIGNER_SET_FILTER_PREDICTED_DATE_TO',

    SET_RAPPORTS_A_SIGNER_IS_LOADING: 'SET_RAPPORTS_A_SIGNER_IS_LOADING',
    SET_ERROR: 'SET_RAPPORTS_A_SIGNER_ERROR',

    SET_EXPORT_XLS_IS_LOADING: 'SET_RAPPORT_EXPORT_XLS_IS_LOADING',
};
